export const headerClasses = {
    header: "bg-[#1c1d21]",
    navContainer: "border-b border-white/10 bg-[#24262c] px-4 py-3 lg:px-6",
    navContent:
      "mx-auto flex max-w-5xl flex-wrap items-center justify-between",
    linkHome:
      "ml-2 rounded-md border border-white/10 bg-black/30 px-4 py-2 text-center text-sm font-bold text-white transition hover:border-accent-color-2 hover:text-accent-color-2 focus:outline-none",
    linkSignIn:
      "ml-2 rounded-md border border-accent-color-1 bg-accent-color-1 px-4 py-2 text-center text-sm font-bold text-white transition hover:border-[#c75a48] hover:bg-[#c75a48] focus:outline-none",
    linkProfileAction:
      "ml-2 flex items-center gap-2 rounded-md border border-white/10 bg-black/30 px-3 py-2 text-center text-sm font-bold text-white transition hover:border-accent-color-2 hover:text-accent-color-2 focus:outline-none",
    dashboardNavContainer:
      "flex flex-wrap items-center justify-center gap-2",
    dashboardNavButton:
      "rounded-md border border-white/10 bg-black/20 px-3 py-2 text-sm font-bold text-slate-400 opacity-75 transition hover:border-accent-color-2 hover:text-accent-color-2 hover:opacity-100 focus:outline-none",
    dashboardNavButtonActive:
      "border-accent-color-1 bg-accent-color-1 text-white opacity-100 shadow-lg shadow-black/30 ring-2 ring-accent-color-1/40 hover:border-accent-color-1 hover:text-white",
    linkProfile: "w-10 h-10 p-1 rounded-full ring-2 ring-gray-300",
    avatar: "",
  };
